import styled, { css } from 'styled-components';
import store from '@/store';
import { SMARTPHONE } from '@/constants';

export const BodyWrapper = styled.div`
  width: 360px;
  max-height: 424px;
  overflow-y: auto;
  overflow-x: hidden;
  display: grid;
  align-content: start;

  ${props => {
    const { core: { targetDevice } } = store.getState();

    switch (targetDevice) {
      case SMARTPHONE: {
        return css`
          width: 100vw;
          max-height: 100%;
        `;
      }
      default: {
        return null;
      }
    }
  }}
`;

export const ModalElementWrapper = styled.div`
  width: 100%;
  height: 66px;
  display: grid;
  align-items: center;
  justify-content: center;
  grid-template-columns: 62px 1fr;
  border-bottom: 1px solid #e1e5e9;
  cursor: pointer;
`;

export const RadioButton = styled.div`
  justify-self: center;
`;

export const Label = styled.div`
  font-size: ${props => (props.fontSize ? props.fontSize : '16px')};
  color: ${props => props.color || '#000000'};
`;
